import styled from 'styled-components';
import Grid from '@material-ui/core/Grid';

interface VideoPreviewProps {
  src?: string | null;
}

export const Videos = styled(Grid)`
  width: auto;
`;

export const VideoPreview = styled.div<VideoPreviewProps>`
  ${({ src, theme: { breakpoints, palette } }) => `
    position: relative;
    width: 110px;
    height: 65px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
    background: linear-gradient(0deg, rgba(32, 59, 92, 0.5), rgba(32, 59, 92, 0.5)), no-repeat center ${
      src ? `/ cover url(${src})` : 'url("/svg/logo-watermark.svg")'
    };

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: ${palette.primary.main};
      opacity: 0.5;
      z-index: 0;
    }

    ${breakpoints.up('sm')} {
      width: 175px;
      height: 105px;
    }
  `};
`;

export const PlayIconWrapper = styled.div`
  ${({ theme: { breakpoints } }) => `
    position: relative;
    width: 30px;
    height: 30px;
    z-index: 1;

    ${breakpoints.up('sm')} {
      width: 42px;
      height: 42px;
    }
  `};
`;

export const IFrameWrapper = styled.div`
  ${({ theme: { breakpoints } }) => `
    margin: 0;

    ${breakpoints.down('sm')} {
      margin: 0 -24px;
    }
    ${breakpoints.down('xs')} {
      margin: 0 -16px;
    }

    & > iframe {
      width: 100%;
      height: 700px;

      ${breakpoints.down('sm')} {
        height: 56vw;
      }
    }
  `};
`;
